import { createFileRoute } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";
import Signup from "@/components/auth/Signup";

export const Route = createFileRoute("/signup")({
	component: () => (
		<PageLayout>
			<Signup />
		</PageLayout>
	),
});
